import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductLine } from '../model/product-line';
import { AuthenticatedHttpService } from './authenticatedhttp.service';

@Injectable()
export class ProductLineService {
    private baseUrl;

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    getProductLine(productLineId: number): Observable<ProductLine> {
        return this._http.get(`${this.baseUrl}/api/productLines/${productLineId}`)
            .map(x => x.json())
            .catch(this._http.handleError);
    }

    getProductLineByPlant(plantId: number): Observable<Array<ProductLine>> {
        return this._http.get(`${this.baseUrl}/api/productLines/${plantId}/plant`)
            .map(x => x.json())
            .catch(this._http.handleError);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/product-line.service.ts